import { EnumHelper } from "@singularsystems/neo-core";

export enum ExportEventTypeEnum {
    Export = 1,
    LatestBookValueHolding = 2,
    DailySync = 3,
}

EnumHelper.decorateEnum(ExportEventTypeEnum, e => {
    e.describe(ExportEventTypeEnum.Export, "Export", "Standard export event.");
    e.describe(ExportEventTypeEnum.LatestBookValueHolding, "Latest Book Value Holding", "LBVH event.");
    e.describe(ExportEventTypeEnum.DailySync, "Daily Sync", "Daily sync event.");
});
